var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"bread-box"},[_c('el-breadcrumb',{attrs:{"separator":">"}},_vm._l((_vm.breadCrumbPathList),function(item){return _c('el-breadcrumb-item',{key:item.name,attrs:{"to":item.path}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }